<template lang="pug">
yz-dialog(v-model="showDialog" persistent max-width="500px")
  yz-card
    yz-dialog-normal-header(title="Remove inventory availability" @close="onCancel")
    yz-dialog-normal-content.px-6.py-6
      .yz-medium-body-md.text-neutral-700 Are you sure you want to remove the inventory from this location?
      .neutral200.rounded-lg.pa-3.mt-3(v-if="locationName")
        .yz-heading-10.text-neutral-700 {{ locationName }}
      .yz-regular-body-sm.text-neutral-700.mt-3 The inventory will no longer be available at this location. It will lose access to the item. You can re-assign it later if needed.
      .yz-regular-body-sm.text-neutral-700.mt-4 Click 'Confirm' to proceed.
    yz-dialog-normal-actions
      .d-flex.align-center.gap-2
        yz-btn(size="lg" text label="Cancel" @click="onCancel")
        yz-btn(size="lg" label="Confirm" color="danger" @click="onConfirm")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    locationName: {
      type: String,
      default: ''
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirmed')
    },
    onCancel() {
      this.$emit('canceled')
      this.showDialog = false
    }
  }
}
</script>
